import type { HTMLAttributes } from 'react';

import { cn } from '@shared/lib/cn';

import {
  CARD_BASE_CLASS,
  CARD_GAP_CLASS,
  CARD_PADDING_CLASS,
  CARD_SHADOW_CLASS,
  type CardShadow,
} from './card.constant';

export interface CardSkeletonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  shadow?: CardShadow;
}

/**
 * Card 의 status=init — 같은 틀 안에 막대 3줄(높이 16, 모서리 4).
 * 너비는 Figma 막대 폭 그대로 128 · 320 · 240(`size.skeleton.*`, DD-19) — 카드가 넓어져도 늘지 않는다(Figma FIXED).
 * 카드가 그보다 좁으면 카드 폭에 맞춘다
 */
export function CardSkeleton({ shadow = 'default', className, ...rest }: CardSkeletonProps) {
  return (
    <div
      aria-hidden="true"
      data-status="init"
      {...rest}
      className={cn(
        'skeleton-pulse',
        CARD_BASE_CLASS,
        CARD_PADDING_CLASS.md,
        CARD_GAP_CLASS.md,
        CARD_SHADOW_CLASS[shadow],
        className,
      )}
    >
      <span className="h-4 w-(--size-skeleton-128) max-w-full rounded-sm bg-bg-muted" />
      <span className="h-4 w-(--size-skeleton-320) max-w-full rounded-sm bg-bg-muted" />
      <span className="h-4 w-(--size-skeleton-240) max-w-full rounded-sm bg-bg-muted" />
    </div>
  );
}
